<template>
    <sui-form @submit="(e) => e.preventDefault()" class="instruction-form-builder">
        <sui-form-field v-for="(parameter, parameterIndex) in metadata.parameters" :key="parameterIndex">
            <label>{{ parameter.name }} <span class="required" v-if="parameter.optional === false">(champ obligatoire)</span></label>
            <div class="description">{{ parameter.description }}</div>

            <template v-if="!!parametersComponents[parameter.type]">
                <component :is="parametersComponents[parameter.type]" v-model="input[parameterIndex]" @input="onChange" />
                <div v-if="!parameter.optional && !isValid(parameter, input[parameterIndex])" class="error">
                    Champ obligatoire
                </div>
            </template>
            
            <template v-else>
                <pre>ERROR: parameter type "{{ parameter.type }}" is not handled</pre>
                <pre>{{ parameter }}</pre>
                <pre>{{ input[parameterIndex] }}</pre>
            </template>
        </sui-form-field>
    </sui-form>
</template>

<script>
import InstructionParameterString from './types/InstructionParameterString.vue';
import InstructionParameterStringArray from './types/InstructionParameterStringArray.vue';
import InstructionParameterAppendPrepend from './types/InstructionParameterAppendPrepend.vue';
import InstructionParameterMatrix from './types/InstructionParameterMatrix.vue';
import InstructionParameterObject from './types/InstructionParameterObject.vue';

export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        value: {
            type: Array,
            default: () => [],
        },
        errors: {
            type: Number,
            default: 0,
        },
        instructionsMetadata: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            parametersComponents: {
                string: InstructionParameterString,
                stringArray: InstructionParameterStringArray,
                appendPrepend: InstructionParameterAppendPrepend,
                matrix: InstructionParameterMatrix,
                object: InstructionParameterObject,
            },
            input: [],
        };
    },
    computed: {
        metadata() {
            return this.instructionsMetadata.find(item => item.name === this.name);
        },
    },
    watch: {
        value: {
            handler(value) {
                this.input = value;
                this.checkErrors();
            },
            immediate: true,
            deep: true,
        }
    },
    methods: {
        checkErrors() {
            let errorsCount = 0;
            for (const index in this.metadata.parameters) {
                const parameter = this.metadata.parameters[index];
                if (!this.isValid(parameter, this.input[index])) {
                    errorsCount++;
                }
            }
            this.$emit('update:errors', errorsCount);
        },
        onChange() {
            this.checkErrors();
            this.$emit('input', this.input);
        },
        isValid(parameter, value) {
            if (parameter.optional) return true;

            if(!value) return false;

            switch (parameter.type) {
                case 'string':
                    return value.trim().length > 0;
                case 'stringArray':
                    return value.map(item => item.trim()).filter(item => item.length > 0).length > 0;
                case 'appendPrepend':
                    return value.trim().length > 0;
                case 'matrix':
                    return value.length > 0;
                case 'object':
                    return Object.keys(value).length > 0;
            }
        }
    }
}
</script>

<style>
.instruction-form-builder .error {
    color: #993333;
    padding: 10px 0;
}

.instruction-form-builder .description {
    color: #666;
    font-size: 12px;
    margin-bottom: 10px;
}

.instruction-form-builder .required {
    color: #993333;
    font-weight: normal;
    font-size: 12px;
}
</style>
